import { lighten } from '@material-ui/core'
import { rgba } from 'polished'
import React from 'react'
import { Box, BoxComponentProps } from 'reoil'
import { palette } from '../theme'

interface BtnBottomProps {
  color?: string
  disabled?: boolean
  unFixed?: boolean
}

const BtnBottom: React.FC<BoxComponentProps & BtnBottomProps> = ({ color=palette.blue, disabled, unFixed, ...props }) => {

  return (
    <Box
      className='btn'
      position={unFixed ? 'relative' : 'fixed'}
      fullWidth
      bottom={20}
      stretch
      p={3}
      borderBox
      style={{zIndex: 999}}
      {...props} onClick={disabled?()=>{}:props.onClick}>
      <Box
        bg={disabled ? lighten(color, .6) : color}
        py={3}
        maxWidth={400}
        fullWidth
        mx='auto'
        borderRadius={50}
        color='white'
        boxShadow={`0 8px 10px -5px ${rgba(color, 0.4)}`}
        center
        pointer>
        {props.children}
      </Box>
    </Box>
  )
}

export default BtnBottom
